import { render } from "./ChoiseCurrency.vue?vue&type=template&id=6a96d014&scoped=true"
import script from "./ChoiseCurrency.vue?vue&type=script&lang=js"
export * from "./ChoiseCurrency.vue?vue&type=script&lang=js"

import "./ChoiseCurrency.vue?vue&type=style&index=0&id=6a96d014&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a96d014"]])

export default __exports__